import React from 'react';
import { FileText } from 'lucide-react';

const ConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  action, 
  useCaseDetails, 
  suggestedAgents,
  hasUploadedFiles = false
}) => {
  if (!isOpen) return null;

  // Check if there's a RAG agent (document assistant)
  const hasRagAgent = suggestedAgents?.some(agent => agent.tool_id === "00006");

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 backdrop-blur-sm">
      <div className="bg-white rounded-lg p-6 max-w-md w-full">
        <h3 className="text-lg font-semibold mb-4">
          {action === "open" ? "Open Existing Use Case?" : "Create New Use Case?"}
        </h3>
        
        <div className="mb-4">
          {action === "open" && useCaseDetails && (
            <div>
              <p className="font-medium">You're about to open:</p>
              <p className="text-primary font-semibold">{useCaseDetails.name}</p>
              <p className="text-sm text-gray-600 mt-1">{useCaseDetails.description}</p>
              
              {hasUploadedFiles && (
                <div className="mt-2 p-2 bg-blue-50 rounded border border-blue-200 flex items-center">
                  <FileText size={16} className="text-primary mr-2" />
                  <p className="text-sm text-primaryDark">
                    Your uploaded documents will be added to this use case.
                  </p>
                </div>
              )}
            </div>
          )}
          
          {action === "create" && useCaseDetails && (
            <div>
              <p className="font-medium">You're about to create:</p>
              <p className="text-green-600 font-semibold">{useCaseDetails.name}</p>
              <p className="text-sm text-gray-600 mt-1">{useCaseDetails.description}</p>
              
              {hasUploadedFiles && (
                <div className="mt-2 p-2 bg-blue-50 rounded border border-blue-200 flex items-center">
                  <FileText size={16} className="text-primary mr-2" />
                  <p className="text-sm text-primaryDark">
                    Your uploaded documents will be included in this use case.
                  </p>
                </div>
              )}
              
              {suggestedAgents && suggestedAgents.length > 0 && (
                <div className="mt-2">
                  <p className="font-medium">With {suggestedAgents.length} suggested agents:</p>
                  <ul className="text-sm text-gray-700 list-disc pl-5">
                    {suggestedAgents.map((agent, index) => (
                      <li key={index} className={agent.tool_id === "00006" ? "text-primary font-medium" : ""}>
                        {agent.name} {agent.tool_id === "00006" && "(Document Assistant)"}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          )}
        </div>
        
        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;